module.exports = __webpack_public_path__ + "img/SES_4069007880.04ace84b.jpg";